/**
 * The generic inline notice (UX spec §3): a title, an optional line of copy
 * and at most one action. Used by `evalPending` today; M2 reuses it for the
 * challenge-declined and another-tab copies.
 */
import React from 'react';
import {StyleSheet, View} from 'react-native';

import {RADIUS, SPACE} from '../../theme/tokens';
import {useV2Theme} from '../../theme/useV2Theme';
import {Button, Txt} from '../../ui';

export type NoticeCardProps = {
  title: string;
  body?: string;
  actionLabel?: string;
  onAction?: () => void;
};

export default React.memo(function NoticeCardView({
  title,
  body,
  actionLabel,
  onAction,
}: NoticeCardProps) {
  const tokens = useV2Theme(s => s.tokens);
  return (
    <View
      style={[
        styles.card,
        {
          backgroundColor: tokens.evTint,
          boxShadow: `inset 0 0 0 1px ${tokens.evLine}`,
        } as any,
      ]}>
      <Txt variant="cardTitle">{title}</Txt>
      {!!body && (
        <Txt variant="body" tone="muted">
          {body}
        </Txt>
      )}
      {!!actionLabel && (
        <View style={styles.action}>
          <Button
            label={actionLabel}
            variant="primaryFlat"
            onPress={onAction}
          />
        </View>
      )}
    </View>
  );
});

const styles = StyleSheet.create({
  card: {
    padding: 14,
    paddingHorizontal: SPACE.lg,
    borderRadius: RADIUS.event,
    gap: 6,
  },
  action: {
    alignSelf: 'flex-start',
    marginTop: 6,
  },
});
